import { Pipe, PipeTransform } from '@angular/core'
import { deepCopy } from '@engineering11/utility'

@Pipe({ name: 'deepCopy' })
export class DeepCopyPipe implements PipeTransform {
  transform<T>(value: T): T {
    return deepCopy(value)
  }
}
